import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class EntityStore {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	subscribeFeed(feedId, callback) {
		const args = {
			filterType: "entities-by-feed",
			feedId: feedId
		};
		return this._rc.subscribe("ecosystem", "/entities", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	subscribeExternalFeed(feedId, callback) {
		const args = {
			filterType: "all",
			feedId: feedId
		};
		return this._rc.subscribe("ecosystem", "/feedEntities", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	subscribeEventPinnedItems(eventId, callback) {
		const args = {
			filterType: "event",
			eventId: eventId
		};
		return this._rc.subscribe("ecosystem", "/feedEntities", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	updateEntity(app, entityType, entityId, entity, callback) {
		const url = `/ecosystem/api/entities/${entityId}`;
		const body = JSON.stringify(entity);
		this._restClient.exec_put(url, body, callback);
	}

	createEntity(app, entityType, entity, callback) {
		const url = "/ecosystem/api/entities";
		entity["app"] = app;
		entity["entityType"] = entityType;
		const body = JSON.stringify(entity);
		this._restClient.exec_post(url, body, callback);
	}

	deleteEntity(app, entityType, entityId, callback) {
		const url = `/ecosystem/api/entities/${entityId}`;
		this._restClient.exec_delete(url, callback);
	}

	restoreEntity(entityId, callback) {
		const url = `/ecosystem/api/entities/${entityId}/restore`;
		const body = JSON.stringify({ isDeleted: false });
		this._restClient.exec_put(url, body, callback);
	}

	// shares argument - supports multiple org: level VIEW|EDIT
	// for both sharing and un-sharing
	//{
	//    "mariner_group":  "EDIT" ,
	//    "some_other_org":  "VIEW"
	//}
	shareEntity(entityId, shares, callback) {
		const url = `/ecosystem/api/entities/${entityId}/share`;
		const body = JSON.stringify({ shares: shares });
		this._restClient.exec_put(url, body, callback);
	}

	unshareEntity(entityId, shares, callback) {
		const url = `/ecosystem/api/entities/${entityId}/unshare`;
		const body = JSON.stringify({ shares: shares });
		this._restClient.exec_put(url, body, callback);
	}

	getMyShapes(callback, filterType) {
		let url;
		if (filterType) {
			url = `/ecosystem/api/entities?et=shapes&app=map-app&filter=${filterType}`;
		} else {
			url = "/ecosystem/api/entities?et=shapes&app=map-app&filter=all";
		}
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get all cameras a user is able to link on a given entity
	 * @param {function} callback
	 */
	getEntitiesForLinking(entityId, entityType, query, pageSize, callback) {
		const url = `/ecosystem/api/entities/${entityId}/linkable?entityType=${entityType}&query=${query}&pageSize=${pageSize}`;
		this._restClient.exec_get(url, callback);
	}
}
